import { SortDirection } from '@openx/types/tableCriteria.ts';
import type { TFunction } from 'i18next';

export const AD_DURATION_LABELS = {
  '0-15': '0 - 15 s',
  '16-30': '16 - 30 s',
  '31-45': '31 - 45 s',
  '46-60': '46 - 60 s',
  '61-75': '61 - 75 s',
  '76-90': '76 - 90 s',
  '91-120': '91 - 120 s',
  '>120': '>120 s',
  unmatched: 'Unmatched',
} as const;

export const AD_DURATION_LABELS_ORDER = [
  '0 - 15 s',
  '16 - 30 s',
  '31 - 45 s',
  '46 - 60 s',
  '61 - 75 s',
  '76 - 90 s',
  '91 - 120 s',
  '>120 s',
  'Unmatched',
] as const;

export const getAdDurationLabel = (adDuration: string, t: TFunction): string => {
  const label = AD_DURATION_LABELS[adDuration as keyof typeof AD_DURATION_LABELS];

  if (label) {
    return t(label);
  }

  return adDuration;
};

export const sortAdDurationDataByLabel = <T extends { ad_duration: string }>(
  data: T[],
  direction: SortDirection | 'asc' | 'desc' = SortDirection.ASC
): T[] => {
  return [...data].sort((a, b) => {
    const labelA = AD_DURATION_LABELS[a.ad_duration as keyof typeof AD_DURATION_LABELS] ?? a.ad_duration;
    const labelB = AD_DURATION_LABELS[b.ad_duration as keyof typeof AD_DURATION_LABELS] ?? b.ad_duration;

    const indexA = AD_DURATION_LABELS_ORDER.indexOf(labelA as (typeof AD_DURATION_LABELS_ORDER)[number]);
    const indexB = AD_DURATION_LABELS_ORDER.indexOf(labelB as (typeof AD_DURATION_LABELS_ORDER)[number]);

    const orderA = indexA === -1 ? Infinity : indexA;
    const orderB = indexB === -1 ? Infinity : indexB;

    if (direction === SortDirection.DESC) {
      return orderB - orderA;
    }

    return orderA - orderB;
  });
};
